import { render, staticRenderFns } from "./formularioRegistro.vue?vue&type=template&id=7ce0036b&scoped=true"
import script from "./formularioRegistro.vue?vue&type=script&lang=js"
export * from "./formularioRegistro.vue?vue&type=script&lang=js"
import style0 from "./formularioRegistro.vue?vue&type=style&index=0&id=7ce0036b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce0036b",
  null
  
)

export default component.exports